import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Field } from "redux-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { required, confirmation, length } from "redux-form-validators";

import { showToast } from "../../../helpers/notify";
import { Button, Input } from "../../../components/Field";
import { getPasswordValidationRegex } from "../../../helpers/input";
import Text from "../../../components/Text";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import AsyncGet from "../../../components/AsyncGet";
import AsyncForm from "../../../components/AsyncForm";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function ResetPassword(props) {
    const { 
        title = "", 
        description = "", 
        bottom_text = "", 
        button_text = "", 
        bg_image = "" 
    } = props;
    const navigate = useNavigate();
    const params = useParams();
    const [step, setStep] = useState(1);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [hash, setHash] = useState(false);
    const userProfile = useSelector((state) => state.storage.data);

    useEffect (() => {
        if(get(userProfile, 'id', null) !== null){
            navigate('/profile');
        }
        // eslint-disable-next-line
    } ,[])

    useEffect(() => {
        if (get(params, 'hash')) {
            setHash(get(params, 'hash'));
        }
    }, [params]);

    if (!hash) {
        return null;
    }

    return (
        <Section className={style.signin}>
            <div className={style.signinWrapper}>
                <div className={style.signinBg}>
                    <Background src={bg_image} size="2560x1440" />
                </div>
                {
                    step === 1 &&
                    <div className={style.formWrapper}>
                        <AsyncGet
                            url="/account/reset-hash-verify"
                            method="post"
                            paramsData={{ hash }}
                            loadOnMount={true}
                            permissionText={false}
                            render={({ fetching, status }) => {
                                return (
                                    <>
                                        {
                                            fetching === false && status !== 200 &&
                                            <div className={`${style.formWrapperCenter}`}>
                                                <div className={style.formRow}>
                                                    <div className={style.formHeader}>
                                                        <div className={style.formTitleWrapper}>
                                                            <Title 
                                                                align="center" 
                                                                className={style.formTitle} 
                                                                tag="h3"
                                                            >
                                                                Reset Password
                                                            </Title>
                                                        </div>
                                                        <div className={style.formDescription}>
                                                            <Text text="Your password reset hash has expired" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={style.formRow}>
                                                    <Link 
                                                        className={style.link} 
                                                        to="/forgot-password"
                                                    >
                                                        Return to for forgot password page
                                                    </Link>
                                                </div>
                                            </div>
                                        }
                                        {
                                            fetching === false && status === 200 &&
                                            <AsyncForm
                                                url="/account/reset"
                                                permission={false}
                                                showToastOnSuccess={false}
                                                initialValues={{
                                                    hash: hash
                                                }}
                                                onSave={({ data }) => {
                                                    if (get(data, "status") === 200) {
                                                        setStep(2);
                                                    } else {
                                                        showToast(data.message);
                                                    }
                                                }}
                                                render={({ fetching }) => (
                                                    <div className={style.form}>
                                                        <div className={style.formRow}>
                                                            <div className={style.formHeader}>
                                                                <div className={style.formTitleWrapper}>
                                                                    <Title className={style.formTitle} tag="h3">{title}</Title>
                                                                </div>
                                                                {
                                                                    description !== "" && (
                                                                        <div className={style.formDescription}>
                                                                            <Text text={description} />
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className={`${style.formRow} ${style.formRowHide}`}>
                                                            <Field
                                                                name="hash"
                                                                component={Input}
                                                                validate={required()}
                                                                type="hidden"
                                                            />
                                                        </div>
                                                        <div className={style.formRow}>
                                                            <div className={style.formFieldRow}>
                                                                <Field
                                                                    name="password"
                                                                    type={showPassword ? "text" : "password"}
                                                                    component={Input} validate={[required(), length({ minimum: 12 }), getPasswordValidationRegex()]}
                                                                    placeholder="New Password"
                                                                    label="Create password"
                                                                    required={true}
                                                                />
                                                                <Link 
                                                                    className={style.show} 
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                >
                                                                    {showPassword ? "Hide" : "Show"}
                                                                    <span className={`${style.dropDown} ${style.right}`}></span>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        <div className={style.formRow}>
                                                            <div className={style.formFieldRow}>
                                                                <Field
                                                                    name="confirm_password"
                                                                    type={showConfirm ? "text" : "password"}
                                                                    component={Input}
                                                                    validate={[required(), confirmation({ field: 'password' })]}
                                                                    placeholder="Confirm Password"
                                                                    label="confirm password"
                                                                    required={true}
                                                                />
                                                                <Link 
                                                                    className={style.show} 
                                                                    onClick={() => setShowConfirm(!showConfirm)}
                                                                >
                                                                    {showConfirm ? "Hide" : "Show"}
                                                                    <span className={`${style.dropDown} ${style.right}`}></span>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        <div className={`${style.formRow} ${style.formSubmit}`}>
                                                            <Button
                                                                color="buttonPrimary"
                                                                size="buttonFullWidth"
                                                                submit={true}
                                                                fetching={fetching}
                                                                label={button_text}
                                                            />
                                                        </div>
                                                        <div className={`${style.formRow} ${style.formRowCol}`}>
                                                            <Editor text={bottom_text} />
                                                        </div>
                                                    </div>
                                                )}
                                            />
                                        }
                                    </>
                                )
                            }}
                        />
                    </div>
                }
                {
                    step === 2 &&
                    <div className={`${style.formWrapper} ${style.formWrapperCenter}`}>
                        <div className={style.formRow}>
                            <div className={style.formHeader}>
                                <div className={style.formTitleWrapper}>
                                    <Title align="center" className={style.formTitle} tag="h3">{title}</Title>
                                </div>
                                <div className={style.formDescription}>
                                    <Text text="Password was reset successfully" />
                                </div>
                            </div>
                        </div>
                        <div className={style.formRow}>
                            <Link className={style.link} to="/sign-in">Return to sign in page</Link>
                        </div>
                    </div>
                }
            </div>
        </Section>
    )
}